import { parse } from "valibot"
import clampNumber from "../../../../lib/ldsh/clampNumber"
import { getDeviceUserPreference, setDeviceUserPreference } from "./deviceUserPreferencesSignal"
import { PIXELATION_SHADER_INTENSITY_VALUE_MAX, PIXELATION_SHADER_INTENSITY_VALUE_MIN, PixelationShaderIntensityValueSchema } from "./PixelationShaderIntensityValue"

export function updatePixelationShaderIntensityValue(newValue : number): void {
  newValue = clampNumber(newValue,
    PIXELATION_SHADER_INTENSITY_VALUE_MIN,
    PIXELATION_SHADER_INTENSITY_VALUE_MAX)

  console.log('updatePSIV', getDeviceUserPreference().psiv, '->', newValue)

  const parsedNewValue = parse(PixelationShaderIntensityValueSchema, newValue)

  setDeviceUserPreference({
    ...getDeviceUserPreference(),
    psiv: parsedNewValue,
  })
}
